<template>
  <div class="search">
    <h2 class='title is-4'>Product Search</h2>
    <input type='text' ref='search' class='search_box' v-on:keyup.enter="search" v-model='search_term' />

    <div v-if="data.length > 0" class='results'>
      <h3 class='title is-5'>Results</h3>
      <table class='table is-striped is-hoverable'>
        <thead>
          <tr>
            <th>SKU</th>
            <th>Title</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(s) in data" v-bind:key="s.id">
            <td>{{ s.sku }}</td>
            <td>{{ s.title }}</td>
            <td><router-link class="button is-small is-fullwidth is-info" v-bind:to="'/products/'+ s.product_id +'/skus#'+ s.id">View</router-link></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search_box {
  width : 100%;
  padding : 0.75rem;
  font-size : 2rem;
}
.results {
  padding : 2rem 0;
}
</style>

<script>
export default {
  name : 'search',
  data : function(){
    return {
      search_term : '',
      data        : []
    }
  },
  mounted(){
    this.$refs.search.focus()
  },
  methods : {
    search : function(){
      // console.log(this.search_term);
      this.callAPI('get', 'skus/freesearch', { search_term : this.search_term })
        .then((res) => {
          this.data = res.data;
          // console.log(this.data);
        })
        .catch((err) => { console.error(err); });
    }
  }
};
</script>